import { POST_LOADER_DELAY } from '@/constants';
import { IComponent } from '@/services/component';
import messages from '../messages';

export default function(context: any) {
  context.$store.commit('loader/ADD', {
    title: 'Creating component',
    promise: context.create().then(
      (component: IComponent) => {
        context.$router.push({
          name: 'component',
          params: {
            componentId: component.id,
          },
        });
      })
      .catch((error: any) => {
        console.error(error);

        context.$store.commit('dialog/CREATE', {
          title: 'Error :(',
          content: messages.ERROR_COMPONENT_CREATE,
          compact: true,
          delay: POST_LOADER_DELAY,
          buttons: [
            {
              text: 'Close',
              click: (dialog: any) => dialog.close(),
            },
          ],
        });
      }),
    });
}
